import React, { memo } from 'react'
import { DropdownItem, Icon } from 'common-components'
import CheckIcon from 'assets/svgr-icons/Check.svg'
import * as Styled from './styled'
import * as DropdownItemStyled from 'common-components/DropdownItem/styled'
import { IOption } from './types'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'

interface IDropdownContentProps {
  options: Array<IOption>
  selectedValue: string | number | null
  onSelect: (value: string | number | null) => void
}

const DropdownContent: React.FC<IDropdownContentProps> = ({
  options,
  selectedValue,
  onSelect
}) => {
  return (
    <Styled.DropdownListWrapper>
      <DropdownItem
        key="all"
        title={translate(T.ALL_LABEL)}
        isSelected={selectedValue === null}
        onSelect={() => onSelect(null)}
      />
      {options.map(option => {
        const isSelected = option.value === selectedValue

        return (
          <DropdownItem
            key={option.value.toString()}
            title={option.label}
            isSelected={isSelected}
            onSelect={() => onSelect(option.value)}
            renderRightContent={() => {
              if (isSelected && option.description) {
                return (
                  <DropdownItemStyled.CheckmarkWrapper>
                    <Icon
                      icon={<CheckIcon />}
                      size="medium"
                      color="primaryDark"
                    />
                  </DropdownItemStyled.CheckmarkWrapper>
                )
              }
              return null
            }}
          />
        )
      })}
    </Styled.DropdownListWrapper>
  )
}

export default memo(DropdownContent)
